<template>
  <section
    class="bottom-comment fixed bottom-0 px-4 py-2.5"
    :class="{ 'bg-white': theme === 'light', 'bg-black': theme === 'dark' }"
  >
    <open-app-btn :extinfo="extinfo">
      <component :is="'style'">
        .botoom-comment-box { width: {{ commentBoxWidth }}; display:flex; align-items:
        center; justify-content: space-between; gap: {{ rootRem * 1.25 }}px; }
        .bottom-comment-input { background-color: #f5f5f5; height: {{ rootRem * 1.75 }}px;
        flex-grow: 1; gap: {{ rootRem * 0.25 }}px; border-radius: 9999px; color: #999;
        display:flex; align-items: center; font-size: {{ rootRem * 0.875 }}px; padding: 0
        {{ rootRem * 0.5 }}px; } .bottom-comment-operate { height: {{ rootRem }}px; }
        .text-666 { color: #666; } .bg-30 { background-color: #303030; }
      </component>
      <div class="botoom-comment-box flex items-center justify-between gap-5">
        <div class="bottom-comment-input" :class="{ 'bg-30': theme === 'dark' }">
          <img
            v-if="theme === 'light'"
            class="bottom-comment-operate"
            src="@/assets/images/comment/light-edit.png"
          />
          <img
            v-else-if="theme === 'dark'"
            class="bottom-comment-operate"
            src="@/assets/images/comment/dark-edit.png"
          />
          <span>说点什么...</span>
        </div>
        <div class="text-666 flex items-center gap-1 text-sm">
          <img
            v-if="theme === 'light'"
            src="@/assets/images/comment/heart.png"
            alt="点赞"
            class="bottom-comment-operate"
          />
          <img
            v-else-if="theme === 'dark'"
            src="@/assets/images/comment/heart.png"
            alt="点赞"
            class="bottom-comment-operate"
          />
          <span>{{ formatTenThousand(likeNum) }}</span>
        </div>
        <img
          v-if="theme === 'light'"
          src="@/assets/images/comment/light-collect.png"
          alt="收藏"
          class="bottom-comment-operate"
        />
        <img
          v-else-if="theme === 'dark'"
          src="@/assets/images/comment/dark-collect.png"
          alt="收藏"
          class="bottom-comment-operate"
        />
        <img
          v-if="theme === 'light'"
          src="@/assets/images/comment/light-share.png"
          alt="分享"
          class="bottom-comment-operate"
        />
        <img
          v-else-if="theme === 'dark'"
          src="@/assets/images/comment/dark-share.png"
          alt="分享"
          class="bottom-comment-operate"
        />
      </div>
    </open-app-btn>
  </section>
</template>

<script setup lang="ts">
import { useRem } from '@/utils/hooks';
import { formatTenThousand } from '@/utils';

const props = withDefaults(
  defineProps<{
    theme?: 'dark' | 'light';
    extinfo: string;
    likeNum: number;
  }>(),
  {
    theme: 'light',
  },
);
const { width: windowWidth } = useWindowSize();
const commentWidth = computed(() =>
  windowWidth.value > 640 ? '640px' : `${windowWidth.value}px`,
);
const borderTop = computed(() =>
  props.theme === 'light' ? '1px solid #f5f5f5' : 'none',
);

const rootRem = useRem();
const commentBoxWidth = computed(
  () => `${(windowWidth.value > 640 ? 640 : windowWidth.value) - rootRem.value * 2}px`,
);
</script>
<style lang="scss" scoped>
.bottom-comment {
  width: v-bind('commentWidth');
  border-top: v-bind('borderTop');
}
</style>
